import { Box, CircularProgress } from '@mui/material';

export default function PageLoadingFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        width: '100%',
        px: 2,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
